import { call, put, takeLatest } from "redux-saga/effects";
import ApiService from "../../../common/services/api.service";
import {
  findEntityAndObjectByFiltersError,
  findEntityAndObjectByFiltersSuccess,
  findEntityByFiltersError,
  findEntityByFilterSuccess,
  findObjectByFiltersError,
  findObjectByFilterSuccess,
  receiveCityError,
  receiveCitySuccess,
  receiveCompanyError,
  receiveCompanySuccess,
  receivePurposeError,
  receivePurposeSuccess
} from '../actions/search';
import {
  SEARCH_GET_ENTITY_OBJECT_REQUEST,
  SEARCH_GET_ENTITY_REQUEST,
  SEARCH_GET_OBJECT_REQUEST,
  SEARCH_RECEIVE_CITY_REQUEST,
  SEARCH_RECEIVE_COMPANY_REQUEST,
  SEARCH_RECEIVE_PURPOSE_REQUEST,
} from "../../../common/constants/action-constants";

function* searchFindEntityObject(action: any) {
  try {
    const result = yield call(ApiService.post, "/search", action.requestData);
    yield put(findEntityAndObjectByFiltersSuccess(result.data));
  } catch (error) {
    yield put(findEntityAndObjectByFiltersError(error));
  }
}

function* searchFindEntity(action: any) {
  try {
    const result = yield call(
      ApiService.post,
      "/search/entities",
      action.requestData
    );
    yield put(findEntityByFilterSuccess(result.data));
  } catch (error) {
    yield put(findEntityByFiltersError(error));
  }
}

function* searchFindObject(action: any) {
  try {
    const result = yield call(
      ApiService.post,
      "/search/objects",
      action.requestData
    );
    yield put(findObjectByFilterSuccess(result.data));
  } catch (error) {
    yield put(findObjectByFiltersError(error));
  }
}

function* searchReceiveCityName(action: any) {
  try {
    const result = yield call(
      ApiService.post,
      "/search/city",
      action.requestData
    );
    yield put(receiveCitySuccess(result.data));
  } catch (error) {
    yield put(receiveCityError(error));
  }
}

function* searchReceiveCompany(action: any) {
  try {

    const companies = yield call(
      ApiService.post,
      "/search/entity_company",
      action.data
    );
    yield put(receiveCompanySuccess(companies.data));
  } catch (error) {
    yield put(receiveCompanyError(error));
  }
}

function* searchReceivePurposes(action) {
  try {
    const result = yield call(
      ApiService.post,
      "/search/purpose",
      action.requestData
    );
    yield put(receivePurposeSuccess(result.data, action.requestData.inputValue));
  } catch (error) {
    yield put(receivePurposeError(error));
  }
}

export default function* actionGlobalSearch() {
  yield takeLatest(SEARCH_GET_ENTITY_OBJECT_REQUEST, searchFindEntityObject);
  yield takeLatest(SEARCH_GET_ENTITY_REQUEST, searchFindEntity);
  yield takeLatest(SEARCH_GET_OBJECT_REQUEST, searchFindObject);
  yield takeLatest(SEARCH_RECEIVE_CITY_REQUEST, searchReceiveCityName);
  yield takeLatest(SEARCH_RECEIVE_COMPANY_REQUEST, searchReceiveCompany);
  yield takeLatest(SEARCH_RECEIVE_PURPOSE_REQUEST, searchReceivePurposes);
}
